<template>
  <section class="px-4 py-32 mx-auto max-w-7xl">
    <div class="w-full mx-auto text-left md:w-11/12 xl:w-8/12 md:text-center">
      <h1
        class="mb-3 text-4xl font-bold text-green-900 md:text-5xl md:leading-tight md:font-extrabold"
        >Human existence is quite impossible without the presence of a healthy
        ecosystem.</h1
      >
      <p class="mb-6 text-lg text-gray-500 md:text-xl md:leading-normal">
        We’re on a mission to deliver on time To halt and reverse environmental
        degradation and depletion of natural resources, nurture the earth's
        ecological and cultural diversity, and secure sustainable livelihoods.
      </p>
    </div>
  </section>

  <section class="dark:bg-coolGray-800 dark:text-coolGray-100">
    <div
      class="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl"
    >
      <div>
        <h2
          class="text-3xl green-700 font-bold tracking-tight text-center sm:text-5xl text-green"
          >Services we offer</h2
        >
        <p
          class="max-w-3xl mx-auto mt-4 text-xl text-center dark:text-coolGray-400"
          >Every year, we lose a huge number of forest life due to forest fire.
          We must find a solution to this.</p
        >
      </div>
      <div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <h3
            class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-coolGray-50"
            >The are many ways of Conserving the Environment</h3
          >
          <p class="mt-3 text-lg dark:text-coolGray-400"
            >Natural non-renewable resources must be utilized properly</p
          >
          <div class="mt-12 space-y-12">
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >Events</h4
                >
                <p class="text-sm dark:text-coolGray-400"
                  >Environmental awareness and event organiser.</p
                >
              </div>
            </div>
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >Eco-friendly chemicals</h4
                >
                <p class="text-sm dark:text-coolGray-400"
                  >Supply and application of eco-friendly chemicals on the
                  environment(herbicides, repellant, water dye,etc).</p
                >
              </div>
            </div>
            <div class="flex">
              <div class="flex-shrink-0">
                <div
                  class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-7 h-7"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg font-medium leading-6 dark:text-coolGray-50"
                  >Supply of Eco-friendly stationery</h4
                >
                <p class="text-sm dark:text-coolGray-400"
                  >Supply of Eco-friendly stationery
                  (bags,pens,pencils,booklets).</p
                >
              </div>
            </div>
          </div>
        </div>
        <div aria-hidden="true" class="mt-10 lg:mt-0">
          <img
            src="https://source.unsplash.com/random/360x480"
            alt=""
            class="mx-auto transition duration-500 ease-in-out transform hover:-translate-y-1 rounded-lg shadow-lg dark:bg-coolGray-500"
          />
        </div>
      </div>
      <div>
        <div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
          <div class="lg:col-start-2">
            <h3
              class="text-2xl font-bold tracking-tight sm:text-3xl dark:text-coolGray-50"
              >Forest Conservation</h3
            >
            <p class="text-sm dark:text-coolGray-400"
              >We know that plants and trees are the essential sources of air,
              food as well as other day-to-day products we use. Forests are the
              dwelling place of different living creatures and a single
              disturbance in the ecosystem can cause disruption in the water
              cycle as well as the food chain.</p
            >
            <div class="mt-12 space-y-12">
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                    >waste dump</h4
                  >
                  <p class="text-sm dark:text-coolGray-400"
                    >Removal of waste dump.</p
                  >
                </div>
              </div>
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                    >Environmental equipment</h4
                  >
                  <p class="text-sm dark:text-coolGray-400"
                    >Supply of Environmental equipment (dust buckets, dust
                    stands, bailers, ph meters,noise instrument.</p
                  >
                </div>
              </div>
              <div class="flex">
                <div class="flex-shrink-0">
                  <div
                    class="flex items-center justify-center w-12 h-12 rounded-md dark:bg-violet-400 dark:text-coolGray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-7 h-7"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="ml-4">
                  <h4
                    class="text-lg font-medium leading-6 dark:text-coolGray-50"
                    >Environmental awareness</h4
                  >
                  <p class="text-sm dark:text-coolGray-400"
                    >Environmental awareness material designs and manufacturing,
                    banners,boardspamphlets,posters, T-shirt,etc.</p
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-10 transition duration-500 ease-in-out transform hover:-translate-y-1 lg:mt-0 lg:col-start-1 lg:row-start-1"
          >
            <img
              src="https://source.unsplash.com/random/361x481"
              alt=""
              class="mx-auto rounded-lg shadow-lg dark:bg-coolGray-500"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <form @submit="submitHandler" class="bg-white dark:bg-gray-800">
    <div class="max-w-3xl px-6 py-16 mx-auto text-center">
      <h1 class="text-3xl font-semibold text-gray-800 dark:text-gray-100"
        >Want to subscribe to our environmental news ?
      </h1>
      <p class="max-w-md mx-auto mt-5 text-gray-500 dark:text-gray-400"
        >Public awareness pertaining to environmental conservation can
        potentially yield promising results</p
      >

      <div
        class="flex flex-col mt-8 space-y-3 sm:space-y-0 sm:flex-row sm:justify-center sm:-mx-2"
      >
        <input
          id="email"
          type="text"
          class="px-4 py-2 text-gray-700 bg-white border rounded-md sm:mx-2 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40"
          placeholder="Email Address"
        />

        <button
          class="px-4 py-2 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-200 transform bg-blue-700 rounded-md sm:mx-2 hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
        >
          Submit
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      takenNamePartials: ["faith", "ejiro", "sam", "josh"],
    };
  },
  methods: {
    submitHandler() {
      alert("Thank you for submitting this !");
    },
    async checkUsername({ value }) {
      // check to see if the username contains any of
      // our partial matches to simulate taken usernames.
      // wrap it in a promise and timeout to simulate an xhr request.
      let match = false;
      await new Promise((resolve) => {
        setTimeout(() => {
          // use .find() to check for matches and bail on first success
          match = this.takenNamePartials.find((partial) =>
            value.includes(partial)
          );
          resolve();
        }, 2000);
      });
      // return the cooreced boolean value of !match
      return !match;
    },
  },
};
</script>
